import { SWReactIcons } from "@similarweb/icons";
import { AlertWrapper, IconWrapper, TextWrapper } from "./styles";

type ChartTooltipAlertTypes = {
    text: string;
};

const ChartTooltipAlert = ({ text }: ChartTooltipAlertTypes) => (
    <AlertWrapper>
        <IconWrapper>
            <SWReactIcons
                size="xs"
                iconName="alert-outlined"
            />
        </IconWrapper>
        <TextWrapper>{text}</TextWrapper>
    </AlertWrapper>
);

export default ChartTooltipAlert;
